import { useAddOnPurchaseCartList } from "../../cart/add-on-purchase/useAddOnPurchaseCartList";
import { ADD_ON_PURCHASE_TYPE } from "../../activity/add-on-purchase/types";
import React, { useEffect, useState, useContext } from "react";
import { message } from "antd";
import MProductGroup from "Components/mobile/cart/MProductGroup";
import axios from "axios";
import {
  cartUrl,
  ACTIVITY_NO_PERMISSION_STATUS_VALUE,
  getActivityNoPermissionStatusLabel,
} from "Utils/constant";
import { getAuthToken } from "Utils/common";
import { AppContext } from "Store";
import Loading from "Components/common/Loading";
import activityIcon from "Images/mobile/activity.svg";
import exchangeIcon from "Images/mobile/exchange.svg";
import { getSelectedSTObj } from "Utils/addressUtils";
import { getAllCartItemIds, getCartItemIds } from "Utils/activityHelper";
import { useLocation, useNavigate } from "react-router-dom";

const MCartSection: React.FC<any> = (props: any) => {
  const { activityId, loadingCart } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const [activityDetail] = useState<any>(
    JSON.parse(localStorage.getItem("activityDetail") || "{}")
  );
  const [loading, setLoading] = useState<boolean>(true);
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  const {
    loginState,
    cartData,
    setCartData,
    activityPermissionMeta,
    refreshCart,
    checkedCartItems,
    setCheckedCartItems,
    setCartCount,
  } = useContext(AppContext);
  const activityNoPermissionLabel = getActivityNoPermissionStatusLabel(
    activityPermissionMeta.activityId === activityId
      ? activityPermissionMeta.customerDataType
      : undefined
  );
  const isAddOnPurchase = activityDetail?.activityBasicType === ADD_ON_PURCHASE_TYPE;
  const addonLoading = useAddOnPurchaseCartList({ activityId, enabled: isAddOnPurchase,
    selectAllOnFirstLoad: true });
  const activityData = cartData.activity;
  const exchangeData = cartData.exchange;
  const {
    ids: exchangeItemIds,
    noSpecifiedCatData: noSpecifiedCatExchangeData,
  } = getCartItemIds(exchangeData);
  const displayExchangeTabNav =
    (!exchangeData || !exchangeItemIds?.length) && !noSpecifiedCatExchangeData;
  const {
    ids: activityItemIds,
    noSpecifiedCatData: noSpecifiedCatActivityData,
  } = getCartItemIds(activityData);
  const displayActivityTabNav =
    (!activityData || !activityItemIds?.length) && !noSpecifiedCatActivityData;
  console.log("displayExchangeTabNav", displayExchangeTabNav);
  console.log("displayActivityTabNav", displayActivityTabNav);
  useEffect(() => {
    if (isAddOnPurchase) {
      setLoading(false);
      return;
    }
    console.log("CartSection rendered");
    if (loginState.status !== "login") return;
    setLoading(true);
    const selectedST = getSelectedSTObj(loginState);
    let reqBody = {
      activityId: activityId,
      shipTo: selectedST?.accountNumber,
      selectAll: firstLoad,
      cartIds: Array.from(checkedCartItems),
    };
    console.log("refreshCartData reqBody", reqBody);
    axios(cartUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthToken(),
      },
      data: reqBody,
    })
      .then((res) => {
        const respData = res.data;
        console.log("cart data", respData);
        console.log("firstLoad", firstLoad);
        if (respData.status === "success") {
          setCartData(respData.data);
          const ids = getAllCartItemIds(respData.data);
          console.log("ids", ids);
          if (firstLoad) {
            setCartCount(ids.length);
            setFirstLoad(false);
            setCheckedCartItems(new Set(ids));
          }
        } else if (respData.status === ACTIVITY_NO_PERMISSION_STATUS_VALUE) {
          message.warning(activityNoPermissionLabel);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [loginState, activityId, refreshCart, isAddOnPurchase]);

  return (
    <div className={isAddOnPurchase ? "cartWrapper addOnPurchaseCart addOnPurchaseCartMobile" : "cartWrapper"}>
      {(loading || addonLoading || loadingCart) && <Loading />}
      <div className="cartTabWrapper">
        <div className="sectionHead">
          <img alt="" src={activityIcon}></img>
          <span className="title">{activityDetail?.activityTypeName}</span>
        </div>
        <div
          className={
            activityData?.matchPromo ? "sectionDesc" : "sectionDesc highlight"
          }
        >
          {activityDetail?.activityTypeDescription}
        </div>
        {activityData?.productGroup.map((item: any, index: number) => {
          return (
            <MProductGroup
              key={index}
              tab="activity"
              groupItem={item}
              isAddOnPurchase={isAddOnPurchase}
              noTabData={displayActivityTabNav}
              cartData={cartData}
              setLoadingCart={setLoading}
              {...props}
            ></MProductGroup>
          );
        })}
        {displayActivityTabNav && (
          <div
            className="btn-link"
            onClick={() => {
              const searchParams = new URLSearchParams(location.search);
              searchParams.set(
                "filter",
                JSON.stringify({
                  tab: "activity",
                })
              );
              const route = `/m/${activityId}?${searchParams.toString()}`;
              console.log(route);

              navigate(route);
            }}
          >
            点击选择
          </div>
        )}
      </div>
      {activityDetail?.activityBasicType === "low_exchange" && (
        <div className="cartTabWrapper exchangeTab">
          <div className="sectionWrapper">
            <div className="sectionHead">
              <img alt="" src={exchangeIcon}></img>
              <div className="title">{activityDetail?.exchangeTypeName}</div>
            </div>
            <div
              className={
                exchangeData?.matchPromo
                  ? "sectionDesc"
                  : "sectionDesc highlight"
              }
            >
              {activityDetail?.exchangeTypeDescription}
            </div>
          </div>
          {exchangeData?.productGroup.map((item: any, index: number) => {
            return (
              <MProductGroup
                key={index}
                tab="exchange"
                groupItem={item}
                isAddOnPurchase={isAddOnPurchase}
                noTabData={displayExchangeTabNav}
                cartData={cartData}
                setLoadingCart={setLoading}
                {...props}
              ></MProductGroup>
            );
          })}
          {displayExchangeTabNav && (
            <div
              className="btn-link"
              onClick={() => {
                const searchParams = new URLSearchParams(location.search);
                searchParams.set(
                  "filter",
                  JSON.stringify({
                    tab: "exchange",
                  })
                );

                const route = `/m/${activityId}?${searchParams.toString()}`;
                console.log(route);
                navigate(route);
              }}
            >
              点击选择
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MCartSection;
